import Component from '@glimmer/component';
import styles from './client-sign-here.module.scss';

export default class SharedSignatureClientSignHere extends Component {
  styles = styles;
}
